import React from "react";
import galleryBg from "../Images/gallerybackground.jpg"; 
import "../GalleryComponent/GalleryComponentCss/ GalleryHero.css";

export default function GalleryHero() {
  return (
    <section
      className="gallery-hero-section"
      style={{ backgroundImage: `url(${galleryBg})` }}
    >
      <div className="gallery-hero-overlay"></div>

      <div className="gallery-hero-content">
        <h1 className="gallery-title">गॅलरी</h1>
        <p className="gallery-subtext">
          आमच्या ग्रामपंचायतीच्या विविध विकासकामांचे, कार्यक्रमांचे आणि उपक्रमांचे
          सुंदर क्षण या गॅलरीतून पाहा. प्रत्येक छायाचित्र गावाच्या प्रगतीचा,
          एकतेचा आणि नवकल्पनांचा साक्षीदार आहे.
        </p>
      </div>
    </section>
  );
}
